import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ProjectAndMangerIds, projectNamesModel } from './DataModel';
import { environment } from "src/environments/environment";
import { BaseResponse, LeaveData, UserDetailsDTO } from "./DataModel";
import * as XLSX from 'xlsx';
import { forEach } from "jszip";
 
 
 
@Injectable({
  providedIn: 'root'
})
 
export class TimeSheetservice {
  private apiUrl = environment.GSDapiUrl;
  private APIurl = environment.apiUrl;
  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  constructor(private http: HttpClient) {
 
  }
 
  getManagersList() {
    const url = `${this.apiUrl}AuditDetails/GetManagerName`;
    return this.http.get(url);
  }
 
  getCommentsList(empIdList: string[]) {
    const url = `${this.APIurl}Timesheet/GetComment`;
   
    let params = new HttpParams();
  empIdList.forEach(empId => {
    params = params.append('employeeID', empId.toString());
  });
 
   
     return this.http.get(url, { params });
   
  }
  GetHolidayList(){
    const url = `${this.APIurl}Timesheet/GetHolidayList`;
    return this.http.get<any>(url, this.httpOptions);
  }
 
  getDifferHistory(empIdList: number[]) {
    const url = `${this.APIurl}Timesheet/GetDifferHistory`;
    let params = new HttpParams();
  empIdList.forEach(empId => {
    params = params.append('ProjectId', empId.toString());
  });
    return this.http.get(url, { params });
  }
 
  getProjectsByManagerId(managerIds: any[], projectName: string ): Observable<BaseResponse<projectNamesModel[]>> {
    let url = `${this.APIurl}Timesheet/GetProjectsByManagerIds`;
    let body = { managerIds: managerIds, searchKey: projectName ?? '' };
    return this.http.post<BaseResponse<projectNamesModel[]>>(url,body);
  }
 
  getProjectName(managerId: number, projectName: string = null): Observable<projectNamesModel[]> {
    let url = `${this.apiUrl}AuditDetails/GetProjectName?managerId=${managerId}`;
    if (projectName) {
      url += `&projectName=${projectName}`;
    }
    return this.http.get<projectNamesModel[]>(url);
  }
 
 
  getAllManagersName(searchTerm?: string): Observable<BaseResponse<UserDetailsDTO[]>> {
    let url = `${this.APIurl}Timesheet/GetManagers`;
    if (searchTerm) {
      url += `?searchtext=${searchTerm}`;
    }
    return this.http.get<BaseResponse<UserDetailsDTO[]>>(url);
  }
  getEmployeeLeaveDatawithEmployeeIds(EmployeeIds: any[], start_date: any, end_date: any) {
    let formdata = new FormData();
   
    formdata.append('EmployeeIds', EmployeeIds.join());
    formdata.append('Startdate', start_date)
    formdata.append('Enddate', end_date)
    let url = `${this.APIurl}Timesheet/GetEmployeetLeaveData`;
    return this.http.post<any>(url, formdata, this.httpOptions);
  }
 
  getPointofContactName(projectAndMangerIds: ProjectAndMangerIds[],startdate:string,enddate:string, searchkey?: string) {
    let url = `${this.APIurl}Timesheet/GetEmployees`;
    let body = { projectAndMangerIds: projectAndMangerIds,startdate :startdate,enddate :enddate, searchKey: searchkey ?? '' };
    return this.http.post<BaseResponse<projectNamesModel[]>>(url,body);
  }
  getAttendanceData(EmployeeId : any[],startdate:string,endadte:string){
    let url = `${this.APIurl}Timesheet/AttendanceData?`
    url+=`StartDate=${startdate}&EndDate=${endadte}`
    return this.http.post<any>(url, EmployeeId,this.httpOptions);
 
  }
 
  getExcelData() {
    return this.http.get(this.apiUrl + 'AuditCreation/GetManagerName');
  }
  sendMail(data){
    const url = `${this.APIurl}Timesheet/SendMail`;
    return this.http.post<any>(url, data, this.httpOptions);
  }
  Email(data:number){
    const url = `${this.APIurl}Timesheet/Email?EmployeeId=${data}`;
    return this.http.get<any>(url, this.httpOptions);
  }
 
  getLeaveData(): Observable<LeaveData[]> {
    return this.http.get<LeaveData[]>(this.APIurl + 'RefreshEmployeeData/UploadTimeSheet');
  }
 
  uploadExcelFile(file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<any>(this.APIurl + 'RefreshEmployeeData/UploadTimeSheet', formData);
  }
 
  parseExcelData(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const workbook = XLSX.read(e.target.result, { type: 'binary' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        resolve(data);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsBinaryString(file);
    });
  }

  getFileStatus(){
    const requestUrl = `${this.APIurl}Timesheet/GetFileStatus`;
    return this.http.get<any>(requestUrl, this.httpOptions);
  }

  saveTimesheetComments(params) {
    const requestUrl = `${this.APIurl}Timesheet/UpsertTimesheetUserComment`;
    return this.http.post<any>(requestUrl, params);
  }

  getManagerCommentForEmployees() {
    const requestUrl = `${this.APIurl}Timesheet/GetCommentsForMultipleProjects`;
    return this.http.get<any>(requestUrl, this.httpOptions);
  }
}
 